import React from 'react';
import css from './footerLink.module.scss';

export const FooterLink = ({href, children}) => (
  <li className={css.footerLinkItem}>
  <a
    href={href}
    rel="noreferrer"
    target="_blank"
    className={css.footerLink}
  >
    {children}
  </a>
</li>
);